import Service from "@core/services/common/Service";
import { AxiosPromise } from "axios";
import expenseItems from "@core/services/common/lists/graphql/expenseItems.graphql";
import {
  PartialExpenseItemsListState
} from "@core/store/types/common/lists/ExpenseItemsListState";

export class ExpenseItemsListService extends Service {
  public static getExpenseItems (
    filters: PartialExpenseItemsListState["filters"],
    limit = 25,
    offset = 0,
    initialExpense?: PartialExpenseItemsListState["filters"]
  ): Promise<AxiosPromise> {
    try {
      console.log(filters);

      const initialExpenseLimit = initialExpense?.id?.length || 0;

      return this.api.get("", {
        params: {
          query: expenseItems,
          variables: {
            limit,
            offset,
            filters,
            initialExpense,
            initialExpenseLimit
          }
        }
      });
    } catch (e) {
      throw e;
    }
  }
}
